/* Ironica — "La mia taglia": consiglia la taglia (IT 38–46) da altezza, peso e forma; la preseleziona in scheda prodotto. */
(function () {
  'use strict';
  var KEY = 'ironica_my_size_v1';
  // IT -> lettera, misure corpo (cm) seno / vita / fianchi
  var T = [
    { it: 38, l: 'XS', b: 82, w: 62, h: 90 },
    { it: 40, l: 'S', b: 86, w: 66, h: 94 },
    { it: 42, l: 'M', b: 90, w: 70, h: 98 },
    { it: 44, l: 'L', b: 96, w: 76, h: 104 },
    { it: 46, l: 'XL', b: 102, w: 82, h: 110 }
  ];
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function read() { try { return JSON.parse(localStorage.getItem(KEY)); } catch (e) { return null; } }
  function save(v) { try { if (v) localStorage.setItem(KEY, JSON.stringify(v)); else localStorage.removeItem(KEY); } catch (e) {} }

  function estimate(h, kg, shape) {
    var bmi = kg / Math.pow(h / 100, 2), dh = h - 165;
    var b = 1.96 * bmi + 46.9 + dh * 0.15, w = 2.28 * bmi + 23.8 + dh * 0.1, hp = 2.07 * bmi + 50.5 + dh * 0.2;
    if (shape === 'pear') { hp += 5; b -= 2; }
    if (shape === 'apple') { w += 6; b += 2; }
    if (shape === 'top') { b += 5; hp -= 2; }
    return { b: b, w: w, h: hp };
  }
  function pick(m, fit) {
    var slack = fit === 'slim' ? 2 : fit === 'loose' ? -3 : 0, i;
    for (i = 0; i < T.length; i++) {
      var r = T[i];
      if (m.b <= r.b + slack && m.h <= r.h + slack && m.w <= r.w + slack + 3) return { row: r, out: 0 };
    }
    return { row: T[T.length - 1], out: 1 };
  }
  function recommend(f) {
    var m = f.bust && f.waist && f.hips ? { b: f.bust, w: f.waist, h: f.hips } : estimate(f.height, f.weight, f.shape);
    var p = pick(m, f.fit);
    if (p.out === 0 && m.b < T[0].b - 4 && m.h < T[0].h - 4 && m.w < T[0].w - 4) p.out = -1;
    return p;
  }

  // la variante "mia" corrisponde al valore del radio?
  function isUniversal(v) { return /unica|^un$|^media$/i.test(v.trim()); }
  function matches(val, pref) {
    var v = String(val).toUpperCase().replace(/\s+/g, '');
    var L = pref.l, it = String(pref.it);
    if (v === L || v === it) return true;
    var parts = v.split(/[\/\-]/);
    if (parts.length > 1) return parts.indexOf(L) > -1 || parts.indexOf(it) > -1;
    return false;
  }

  /* ---------- Modale ---------- */
  var modal, lastFocus;
  function open(tab) {
    modal = modal || $('[data-ims]');
    if (!modal) return;
    lastFocus = document.activeElement;
    modal.hidden = false; document.documentElement.classList.add('ims-lock');
    show(tab || (read() ? 'pick' : 'calc'));
    var f = $('button, input', modal); if (f) f.focus();
  }
  function close() {
    if (!modal) return;
    modal.hidden = true; document.documentElement.classList.remove('ims-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function show(tab) {
    $$('[data-ims-tab]', modal).forEach(function (t) { var on = t.getAttribute('data-ims-tab') === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on); });
    $$('[data-ims-pane]', modal).forEach(function (p) { p.hidden = p.getAttribute('data-ims-pane') !== tab; });
    var cur = read();
    $$('.ims__opt', modal).forEach(function (o) { o.classList.toggle('is-active', !!cur && String(cur.it) === o.getAttribute('data-it')); });
    var res = $('[data-ims-result]', modal); if (res) res.hidden = true;
  }
  function commit(row, note) {
    save({ it: row.it, l: row.l, label: row.l + ' · IT ' + row.it });
    applyAll(true);
    if (note) return;
    close();
  }

  function renderResult(p, f) {
    var res = $('[data-ims-result]', modal), r = p.row;
    var msg = p.out === 1 ? 'Le tue misure sono oltre la nostra taglia 46: scrivici per un consiglio personalizzato.' :
      p.out === -1 ? 'Le tue misure sono sotto la nostra taglia 38: scrivici per un consiglio personalizzato.' : '';
    res.innerHTML = '<p class="ims__rk">La tua taglia</p><p class="ims__big">' + r.l + ' <span>IT ' + r.it + '</span></p>' +
      (msg ? '<p class="ims__note">' + msg + '</p>' : '<p class="ims__note">Ti consigliamo la ' + r.l + ' (IT ' + r.it + '). Se sei tra due taglie, scegli quella più grande per un fit comodo.</p>') +
      '<button type="button" class="ims__btn" data-ims-use="' + r.it + '">Usa questa taglia</button>';
    res.hidden = false;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var o = t.closest('[data-ims-open]');
    if (o) { e.preventDefault(); open(o.getAttribute('data-ims-open') || undefined); return; }
    if (!modal || modal.hidden) return;
    if (t.closest('[data-ims-close]')) { close(); return; }
    var tab = t.closest('[data-ims-tab]'); if (tab) { show(tab.getAttribute('data-ims-tab')); return; }
    var opt = t.closest('.ims__opt');
    if (opt) { var row = T.filter(function (r) { return String(r.it) === opt.getAttribute('data-it'); })[0]; commit(row); return; }
    var use = t.closest('[data-ims-use]');
    if (use) { var rr = T.filter(function (r) { return String(r.it) === use.getAttribute('data-ims-use'); })[0]; commit(rr); return; }
    if (t.closest('[data-ims-reset]')) { save(null); applyAll(false); close(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && !modal.hidden) close(); });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-ims-form]');
    if (!form) return;
    e.preventDefault();
    var fd = function (n) { var el = form.elements[n]; return el ? el.value : ''; };
    var f = { height: parseFloat(fd('height')), weight: parseFloat(fd('weight')), shape: fd('shape') || 'bal', fit: fd('fit') || 'reg',
      bust: parseFloat(fd('bust')) || 0, waist: parseFloat(fd('waist')) || 0, hips: parseFloat(fd('hips')) || 0 };
    var err = $('[data-ims-error]', form);
    if (!(f.height >= 140 && f.height <= 200) || !(f.weight >= 38 && f.weight <= 150)) {
      err.textContent = 'Inserisci altezza (140–200 cm) e peso (38–150 kg).'; err.hidden = false; return;
    }
    err.hidden = true;
    renderResult(recommend(f), f);
  });

  /* ---------- Scheda prodotto ---------- */
  function sizeFieldset() {
    var main = $('#MainContent') || document;
    var sets = $$('fieldset.product-form__controls', main).filter(function (fs) { return !fs.closest('[class*="sticky"]'); });
    return sets.filter(function (fs) { var l = $('legend', fs); return l && /dimens|tagl|size|misur/i.test(l.textContent); })[0] || null;
  }
  function applyPdp(pref, userAction) {
    var fs = sizeFieldset(); if (!fs) return;
    var note = $('[data-ims-note]', fs);
    if (!note) {
      note = document.createElement('div'); note.className = 'ims-note'; note.setAttribute('data-ims-note', '');
      var grp = $('.product-form__controls-group', fs); fs.insertBefore(note, grp || null);
    }
    var inputs = $$('input[type="radio"]', fs);
    inputs.forEach(function (i) { var l = fs.querySelector('label[for="' + i.id + '"]'); if (l) l.classList.remove('is-mine'); });
    var avail = function (i) { return !i.classList.contains('disabled'); };
    var universal = inputs.filter(function (i) { return isUniversal(i.value); });
    var go = function (list) { var a = list.filter(avail)[0]; if (a && !a.checked) a.click(); };
    var hasParam = /[?&]variant=/.test(location.search);

    // Taglia unica: sempre preselezionata, ma vale per le taglie 38–46
    if (inputs.length && universal.length === inputs.length) {
      note.innerHTML = 'Taglia unica: veste dalla <strong>38 alla 46</strong>.';
      go(universal); return;
    }
    var mine = pref ? inputs.filter(function (i) { return matches(i.value, pref); }) : [];
    mine.forEach(function (i) { var l = fs.querySelector('label[for="' + i.id + '"]'); if (l) l.classList.add('is-mine'); });
    if (!pref) {
      note.innerHTML = '<button type="button" class="ims-link" data-ims-open="calc">Trova la tua taglia</button>';
      return;
    }
    if (!mine.length) {
      note.innerHTML = 'La tua taglia (' + pref.label + ') non è disponibile su questo capo. <button type="button" class="ims-link" data-ims-open="pick">Cambia</button>';
      return;
    }
    if (!mine.some(avail)) {
      note.innerHTML = '<strong>La tua taglia (' + pref.label + ') è esaurita</strong> su questo capo. <button type="button" class="ims-link" data-ims-open="pick">Cambia</button>';
      return;
    }
    note.innerHTML = 'La tua taglia: <strong>' + pref.label + '</strong> · <button type="button" class="ims-link" data-ims-open="pick">Cambia</button>';
    if (userAction || !hasParam) go(mine);
  }
  var busy = false;
  function applyAll(user) {
    if (busy) return; busy = true;
    try { applyPdp(read(), user === true); } finally { busy = false; }
  }
  function init() {
    applyAll();
    var t;
    new MutationObserver(function (m) {
      if (busy) return;
      if (!m.some(function (x) { return Array.prototype.some.call(x.addedNodes, function (n) { return n.nodeType === 1 && (n.matches('variant-radios, fieldset') || n.querySelector('fieldset')); }); })) return;
      clearTimeout(t); t = setTimeout(applyAll, 60);
    }).observe($('#MainContent') || document.body, { childList: true, subtree: true });
  }
  window.IronicaMySize = { get: read, recommend: recommend, tables: T };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
